export const gridMediaState = {
    defaultState: {
        activeMedia: null,
        lastActiveMedia: null,
        adaptHeight: window.innerWidth < 600,
    },
    actions: {
        activateMedia: (media, state) => ({...state, activeMedia: media}),
        deactivateMedia: (media, state) => ({...state, lastActiveMedia: media, activeMedia: null}),
        setLastActiveMedia: (media, state) => ({...state, lastActiveMedia: media}),
        toggleAdaptHeight: (_, state) => ({...state, adaptHeight: !state.adaptHeight}),
    },
}
